import React, { useEffect, useRef } from "react";
import { Flex, Heading, Button, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../../utils/colors";
import { useDispatch, useSelector } from "react-redux";
import { updateTenantOnboardingStatusAction } from "../../../actions/tenantActions";
import { TENANT_UPDATE_ONBOARDING_STATUS_RESET } from "../../../constants/tenantConstants";
import {
  listTenantDetails,
  seedDatabaseUpdateOnboardingStatusAction,
} from "../../../actions/tenantActions";
import { getTreatmentPlanStatistics } from "../../../actions/treatmentPlanActions";
import { useNavigate } from "react-router-dom";

const OnboardingStepSuccess = ({ senderIdentityEmail, setOpen }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const navigate = useNavigate();

  const buttonRef = useRef(null); // Ref for the button

  // REDUX
  const dispatch = useDispatch();

  const tenantUpdateOnboardingStatus = useSelector(
    (state) => state.tenantUpdateOnboardingStatus
  );
  const {
    loading: loadingUpdateOnboardingStatus,
    success: successUpdateOnboardingStatus,
    error: errorUpdateOnboardingStatus,
  } = tenantUpdateOnboardingStatus;

  const tenantSeedDatabaseUpdateOnboardingStatus = useSelector(
    (state) => state.tenantSeedDatabaseUpdateOnboardingStatus
  );
  const {
    loading: loadingSeedDatabaseUpdateOnboardingStatus,
    success: successSeedDatabaseUpdateOnboardingStatus,
    error: errorSeedDatabaseUpdateOnboardingStatus,
  } = tenantSeedDatabaseUpdateOnboardingStatus;

  // HANDLERS
  const handleSubmit = () => {
    setOpen(false);
    // dispatch(seedDatabaseUpdateOnboardingStatusAction("completed"));
  };

  // USE EFFECT
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent unwanted behavior
        buttonRef.current?.click(); // Click the submit button
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // useEffect(() => {
  //   if (successSeedDatabaseUpdateOnboardingStatus) {
  //     setOpen(false);

  //     // dispatch(listTenantDetails()); // ✅ Fetch updated details
  //     // dispatch(getTreatmentPlanStatistics());

  //     navigate("/patients");

  //     // dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
  //   } else if (errorSeedDatabaseUpdateOnboardingStatus) {
  //     toast({
  //       title: t("toasts.updateTenantOnboardingStatusError"),
  //       status: "error",
  //       duration: 5000,
  //       isClosable: true,
  //     });

  //     // dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
  //   }
  // }, [
  //   successSeedDatabaseUpdateOnboardingStatus,
  //   errorSeedDatabaseUpdateOnboardingStatus,
  //   navigate,
  // ]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Flex
          direction="column"
          align="center"
          justify="center"
          p="0rem 0rem"
          maxW="800px"
          m="0 auto"
        >
          <Text fontSize="3rem">🎉</Text>

          <Heading as="h2" fontSize="3.5rem" textAlign="center">
            {t("onboarding.questionSuccess")}
          </Heading>

          <Text
            fontSize="1rem"
            fontWeight="500"
            textAlign="center"
            color={textSecondary}
            maxW="80%"
            m="1rem 0 0"
          >
            {t("onboarding.questionSuccessText")}
            <Text as="span" fontWeight="500" color={primaryAlt} ml="0.25rem">
              {senderIdentityEmail}
            </Text>
          </Text>

          <Flex align="center" justify="center" w="100%" gap={4} m="2rem 0 0">
            <Button
              autoFocus
              ref={buttonRef} // Attach ref to button
              type="submit"
              h="3.5rem"
              size="lg"
              borderRadius="10rem"
              onClick={handleSubmit}
              isLoading={loadingSeedDatabaseUpdateOnboardingStatus}
              bg={textPrimary}
              px="3rem"
              color={white}
              transition="all 0.3s ease"
              _hover={{
                bg: primaryAlt,
                color: white,
                opacity: "1",
              }}
              _disabled={{
                cursor: "pointer",
                opacity: "0.5",
              }}
            >
              {t("onboarding.done")}
            </Button>
          </Flex>
        </Flex>
      </form>
    </>
  );
};

export default OnboardingStepSuccess;
